<div class="modal-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <h2 class="modal-title">{{ 'UPLOAD_IMAGES.UPLOAD_BUTTON' | translate }}</h2>
      <button class="close-button" (click)="closeModal()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <div class="modal-content">
      <div class="form-group">
        <label class="form-label">{{ 'DATA_SOURCE' | translate }}</label>
        <app-dropdown
          [(ngModel)]="formData.satellite"
          [options]="satelliteOptions"
          [placeholder]="'SELECT_DATA_SOURCE' | translate">
        </app-dropdown>
      </div>

      <div class="form-group">
        <label class="form-label">{{ 'Date' | translate }}</label>
        <app-date-picker
          [(ngModel)]="formData.date"
          [placeholder]="'01.05.2024'"
          [showIcon]="true"
          [dateFormat]="'dd.mm.yy'">
        </app-date-picker>
      </div>

      <div class="form-group">
        <label class="form-label">{{ 'Регион' | translate }}</label>
        <div class="filter-control region-control">
          <div class="region-selector" [class.region-selector--open]="showRegionDropdown">
            <div class="region-select-button" (click)="toggleRegionDropdown()">
              <span>{{ selectedRegionLabel || (getAllRegionsLabel ? getAllRegionsLabel() : ('ALL_REGIONS' | translate)) }}</span>
              <div class="region-select-actions">
                <button
                  *ngIf="selectedRegion || selectedParentRegion"
                  type="button"
                  class="region-clear-btn"
                  (click)="clearRegionFilter($event)"
                  [title]="'UPLOAD_IMAGES.FILTERS.CLEAR_REGION' | translate"
                >
                  <i class="pi pi-times"></i>
                </button>
                <i class="pi" [ngClass]="showRegionDropdown ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
              </div>
            </div>

            <div class="region-dropdown" *ngIf="showRegionDropdown">
              <div class="region-search">
                <input
                  type="text"
                  [(ngModel)]="regionSearch"
                  (input)="onRegionSearchChange()"
                  [placeholder]="'UPLOAD_IMAGES.REGION_SEARCH' | translate"
                  class="region-search-input"
                />
              </div>

              <div class="region-list">
                <div class="region-item" *ngFor="let region of filteredRegionTree">
                  <div class="region-header" (click)="selectRegion(region)">
                    <i
                      class="pi expand-icon"
                      *ngIf="region.children?.length"
                      [ngClass]="region.expanded || isRegionExpanded(region.id) ? 'pi-minus' : 'pi-plus'"
                      (click)="toggleRegionExpansion(region, $event)"
                    ></i>
                    <span>{{ getLocalizedRegionName ? getLocalizedRegionName(region) : (region.name || '') }}</span>
                  </div>

                  <div class="district-list"
                       *ngIf="region.children?.length && (region.expanded || isRegionExpanded(region.id))">
                    <div
                      class="district-item"
                      *ngFor="let district of region.children"
                      (click)="selectDistrict(region, district, $event)"
                    >
                      {{ getLocalizedRegionName ? getLocalizedRegionName(district) : (district.name || '') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <app-secondary-button
        title="Cancel"
        (action)="onCancel()"
      ></app-secondary-button>
      <app-primary-button
        title="UPLOAD_IMAGES.MODAL_SUBMIT"
        (action)="onSubmit()"
        [disable]="!formData.satellite || !formData.date || (!formData.region && !formData.parentRegion)"
      ></app-primary-button>

    </div>
  </div>
</div>
